import { useQuery } from "@apollo/client";

import {
  VisitServiceReportDocument,
  VisitServiceReportWithTokenDocument,
} from "../../__generated__/graphql";

export function useVisitServiceReport({
  visitId,
  visitToken,
  skip,
}: {
  visitId?: string;
  visitToken?: string | null;
  skip?: boolean;
}) {
  const byId = useQuery(VisitServiceReportDocument, {
    variables: { id: visitId ?? "" },
    skip: skip || !visitId || Boolean(visitToken),
    errorPolicy: "ignore",
    fetchPolicy: "cache-and-network",
  });

  const byToken = useQuery(VisitServiceReportWithTokenDocument, {
    variables: { token: visitToken ?? "" },
    skip: skip || !visitToken,
    errorPolicy: "ignore",
    fetchPolicy: "cache-and-network",
  });

  if (skip) return null;

  return visitToken
    ? byToken.data?.visitByClientWithToken?.serviceReport
    : byId.data?.visit?.serviceReport;
}
